import React from "react";
import { Link } from "react-router-dom";
import NotFounDData from "../assets/not-found.svg";
import "./NotFound.css";

const DEFAULT_EMPTY_MESSAGE = "There's nothing here yet.";

const NotFound = ({
  hasActiveSearch = false,
  message = "",
  emptyMessage = DEFAULT_EMPTY_MESSAGE,
  underline = false,
}) => {
  const textStyle = { color: "#8E8E93" };

  return (
    <div className="flex flex-column justify-center items-center mt-3 text-center">
      <img src={NotFounDData} className="notFoundImage" alt="" />

      {hasActiveSearch ? (
        <div className="notFoundText mt-2" style={textStyle}>
          No Results Found – try a different keyword or{" "}
          <Link to="/" className="mockup-link">
            browse our mockups
          </Link>{" "}
          for inspiration.
        </div>
      ) : (
        <div
          className="notFoundText mt-2"
          style={{
            ...textStyle,
            textDecoration: underline ? "underline" : "none",
          }}
        >
          {message || emptyMessage}
        </div>
      )}
    </div>
  );
};

export default NotFound;
